<template>
  <div class="single_container">
    <div class="personalMainHead">
      <PersonalHead
        type="initiation_single"
        titleName="待发起业务列表"
        :backPath="personalHeadBackPath"
      ></PersonalHead>
    </div>
    <div class="info_box">
      <!-- 回到顶部 -->
      <div class="backtop" @click="onBacktop">
        <i class="el-icon-caret-top"></i>
      </div>

      <div class="label">
        <div class="line"></div>
        <div>业务列表</div>
      </div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="104px"
        class="task_form"
      >
        <div class="row">
          <div class="col">
            <el-form-item label="合同名称:" prop="contractName">
              <el-input
                clearable
                v-model="form.contractName"
                size="mini"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="合同编号:" prop="userBizNumber">
              <el-input
                clearable
                v-model="form.userBizNumber"
                size="mini"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="债务人姓名:" prop="debtorName">
              <el-input
                clearable
                v-model="form.debtorName"
                size="mini"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="债务人手机号:" prop="debtorPhone">
              <el-input
                clearable
                v-model="form.debtorPhone"
                size="mini"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div class="button-box"></div>
        </div>
        <div class="row">
          <div class="col">
            <el-form-item label="导入状态:">
              <!-- <el-input
                  clearable
                  v-model="form.isSucc"
                  size="mini"
                ></el-input> -->
              <div class="item-box">
                <div
                  class="item"
                  @click="onIsSucc(true)"
                  :class="{ active: form.isSucc === true }"
                >
                  正常
                </div>
                <div
                  class="item"
                  @click="onIsSucc(false)"
                  :class="{ active: form.isSucc === false }"
                >
                  异常
                </div>
                <div
                  class="item"
                  @click="onIsSucc('')"
                  :class="{ active: form.isSucc === '' }"
                >
                  全部
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="导入批次:" prop="round">
              <el-input
                clearable
                v-model="form.round"
                size="mini"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="债权人委托方:" prop="creditAssignee">
              <el-select
                size="mini"
                style="width: 100%"
                v-model="form.creditAssignee"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in listAssignee"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="导入备注:" prop="remark">
              <!-- <el-input
                clearable
                v-model="form.remark"
                size="mini"
                placeholder="请输入"
              ></el-input> -->
              <el-select
                size="mini"
                style="width: 100%"
                v-model="form.remark"
                placeholder="请选择"
              >
                <el-option
                  v-for="key in Object.keys(remarkOptions)"
                  :key="key"
                  :label="remarkOptions[key]"
                  :value="key"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="button-box">
            <el-button class="search-button" size="mini" @click="onSearch"
              >查询</el-button
            >
            <el-button
              class="reset-button"
              type="danger"
              size="mini"
              @click="onReset"
              >重置</el-button
            >
          </div>
        </div>
      </el-form>

      <div class="tools">
        <div class="tools-left">
          <div class="number">
            已选择 {{ selectList.length }} 条记录，赋强标的金额
            {{ selectAmount }} 元
          </div>
          <el-button
            :disabled="!selectList.length"
            size="mini"
            type="primary"
            @click="batchDelete(null, 'batch')"
            >批量删除</el-button
          >
          <el-button
            :disabled="!selectSubmitList.length"
            type="primary"
            size="mini"
            @click="saveBatchSubmit(null, 'batch')"
            >批量提交</el-button
          >
        </div>
        <div class="tools-right">
          <el-button
            class="reset-button"
            size="mini"
            type="danger"
            @click="toSingle"
            >手动创建</el-button
          >
          <el-button
            class="reset-button"
            size="mini"
            type="danger"
            @click="batchUploadVisible = true"
            >批量导入</el-button
          >
          <el-button
            class="reset-button"
            type="danger"
            size="mini"
            @click="onRecordList"
            >导入记录</el-button
          >
        </div>
      </div>

      <el-table
        :data="tableData"
        size="mini"
        ref="table"
        @selection-change="handleSelectionChange"
        :header-row-style="{ background: '#F8F8F8' }"
        :header-cell-style="{ background: '#F8F8F8' }"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="index" label="序号" width="60">
        </el-table-column>
        <el-table-column
          prop="contractName"
          label="合同名称"
          width="180"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="contract-name">
              <div class="contract-name-text">{{ scope.row.contractName }}</div>
              <img v-if="scope.row.repeated" src="../../../assets/images/index/cf.png" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="userBizNumber"
          label="合同编号"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="creditAssignee"
          label="债权人委托方"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="repayAmount"
          label="还款金额"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="debtorName"
          label="债务人姓名"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="debtorPhone"
          label="债务人手机号"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>
        <el-table-column prop="succ" label="业务状态" width="100">
          <template slot-scope="scope">
            <div class="status-box">
              <div class="dot" :class="{ 'dot-error': !scope.row.succ }"></div>
              <div>{{ scope.row.succ ? "正常" : "异常" }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="round"
          label="业务来源"
          show-overflow-tooltip
          width="180"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row.round === "手动创建"
                  ? "手动创建"
                  : scope.row.round + "批量"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="生成时间" width="180">
        </el-table-column>

        <!-- <el-table-column prop="round" label="导入批次" width="100">
        </el-table-column> -->
        <!-- <el-table-column prop="createTime" label="导入时间" width="180">
        </el-table-column> -->
        <el-table-column
          prop="comment"
          show-overflow-tooltip
          label="合同备注"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="业务状态备注"
          show-overflow-tooltip
          min-width="200px"
        >
        </el-table-column>
        <el-table-column prop="date" label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              class="red-button"
              @click="onEdit(scope.row)"
              >编辑</el-button
            >
            <!-- <el-button
              type="text"
              size="mini"
              class="red-button"
              v-if="
                (scope.row.succ || scope.row.isSucc) &&
                scope.row.submitStatus === 'UNSUBMIT'
              "
              @click="saveDraft(scope.row, 'single')"
              >存草稿</el-button
            > -->
            <el-button
              type="text"
              v-if="
                (scope.row.succ || scope.row.isSucc) &&
                (scope.row.submitStatus === 'UNSUBMIT' ||
                  scope.row.submitStatus === 'DRAFT')
              "
              size="mini"
              class="red-button"
              @click="saveBatchSubmit(scope.row, 'single')"
            >
              {{ scope.row.submitTime ? "重新提交" : "提交" }}
            </el-button>
            <el-button
              type="text"
              size="mini"
              class="red-button"
              @click="batchDelete(scope.row, 'single')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-box">
        <div class="pagination-left">
          <span>当前列表中 赋强标的 金额总计 {{ totalAmount }} 元</span>
          <i
            @click="getTotalAmount"
            :class="totalAmountLoading ? 'el-icon-loading' : 'el-icon-refresh'"
          ></i>
        </div>

        <pagination
          class="pagination"
          :total="total"
          :page.sync="queryParams.pageNumber"
          :limit.sync="queryParams.pageSize"
          :page-sizes="[10, 100, 500]"
          @pagination="onPagination"
        />
      </div>
    </div>

    <importProgress
      v-if="importProgressShow"
      :progressInfo="progressInfo"
      :fileInfo="fileInfo"
    />

    <batchUpload
      @close="close"
      @onExport="onExport"
      :dialogVisible="batchUploadVisible"
      v-if="batchUploadVisible"
    />
    <uploadRecord
      @close="close"
      v-if="uploadRecordVisible"
      :dialogVisible="uploadRecordVisible"
    />
    <exportResult
      @close="close"
      @submit="getList"
      :visible="exportResultVisible"
      :progressInfo="progressInfo"
      :importId="importId"
    />

    <Loading v-if="isLoading"></Loading>
  </div>
</template>

<script>
import BaseApi from "@lib/baseApi.js";

import batchUpload from "./components/batchUpload.vue";
import uploadRecord from "./components/uploadRecord.vue";
import exportResult from "./components/exportResult.vue";
import importProgress from "./components/importProgress.vue";

import PersonalHead from "../../common/PersonalHead.vue";
import pagination from "@/components/components/pagination/index.vue";
import Loading from "../../common/Loading.vue";
export default {
  name: "",
  props: {},

  components: {
    batchUpload,
    uploadRecord,
    exportResult,
    PersonalHead,
    pagination,
    importProgress,
    Loading,
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  data() {
    return {
      form: {
        contractName: "", // 合同名称
        batchNo: "", // 导入批次号
        userBizNumber: "", // 合同编号
        debtorName: "", // 债务人姓名
        isSucc: "", // 导入状态
        round: "", // 导入批次
        remark: "", // 导入备注
        debtorPhone: "", // 债务人手机号
        creditAssignee: "", // 合同备注信息
      },
      rules: {},
      // 导入备注筛选项
      remarkOptions: {
        MustPresent: "字段不能为空",
        ExcelCellErr: "单元格格式错误",
        InvalidFormat: "数据格式错误",
        ContentToLong: "内容太长",
        ContractFileNotPresent: "对应的word文件不存在",
        AttachFileNotPresent: "对于的pdf或图片文件不存在",
        FileNotPresend: "文件不存在",
        FileTypeError: "文件类型不支持",
        FileConvError: "文件类型转换异常",
        FileDuplicated: "文件重复",
        GenContractFail: "合同生成异常",
        Duplicated: "数据重复",
        OtherError: "其他异常",
        // 'SubmitError': "提交失败",
        importSuccess: "导入成功",
      },

      queryParams: {
        pageNumber: 1,
        pageSize: 10,
      },
      statusMap: { 4: "失败", 5: "完成" },
      tableData: [],
      total: 0,
      businessList: {}, // 信息

      batchUploadVisible: false,
      uploadRecordVisible: false,
      exportResultVisible: false,

      importId: "", // 导入id
      batchNo: "", // 批次号
      importProgressShow: false, // 是否显示导入进度
      progressInfo: {}, // 导入进度信息
      fileInfo: {}, // 导入文件信息

      selectList: [], //  已选
      selectSubmitList: [], // 可提交
      selectAmount: 0, // 已选金额
      totalAmount: 0, // 总金额
      totalAmountLoading: false, // 查询中

      isClick: false,

      listAssignee: [], // 债权人委托方列表

      personalHeadBackPath: "/personal/home",
    };
  },

  created() {},
  mounted() {
    if (sessionStorage.getItem("batchUploadVisible")) {
      this.batchUploadVisible = true;
      sessionStorage.removeItem("batchUploadVisible");
    }
    if (this.$route.query.batchUploadVisible) {
      this.batchUploadVisible = true;
    }
    this.getList();
    this.getListAssignee();
  },

  methods: {
    getList() {
      BaseApi.createRpcToken("/import/businessListQuery", {
        ...this.queryParams,
        ...this.form,
      }).then(
        (data) => {
          if (data.code == 200) {
            let list = data.datas.businessList.list;
            list.forEach((item, index) => {
              if (item.bizData) {
                item.index = index + 1;
                item.bizData = JSON.parse(item.bizData);
              }
            });
            this.tableData = list;
            this.total = data.datas.businessList.totalRow;
            this.businessList = data.datas.businessList;
          } else {
            this.$message.error(data.message);
          }
        },
        (err) => {}
      );
      this.getTotalAmount();
    },

    // 查询
    onSearch() {
      console.log(this.form);
      this.getList();
    },
    // 重置
    onReset() {
      this.form.isSucc = "";
      this.$refs.form.resetFields();
      this.getList();
    },
    // 导入状态
    onIsSucc(isSucc) {
      this.form.isSucc = isSucc;
      this.getList();
    },
    onPagination(data) {
      this.queryParams.pageNumber = data.page;
      this.queryParams.pageSize = data.limit;
      this.getList();
    },

    // 选中
    handleSelectionChange(rows) {
      console.log(rows);
      let selectAmount = 0;
      let selectSubmitList = [];
      rows.forEach((item) => {
        selectAmount += Number(item.repayAmount || "0");

        if (
          (item.succ || item.isSucc) &&
          (item.submitStatus === "UNSUBMIT" || item.submitStatus === "DRAFT")
        ) {
          // 可提交
          selectSubmitList.push(item);
        }
      });
      console.log(selectAmount);

      this.selectAmount = selectAmount;
      this.selectList = rows;
      this.selectSubmitList = selectSubmitList;
    },

    // 打开上传记录
    onRecordList() {
      this.uploadRecordVisible = true;
    },

    onExport(data) {
      // 案件导入后，调用该方法，会传importId 用来查询导入信息
      this.importId = data.importId;
      this.batchNo = data.batchNo;
      this.fileInfo = data.fileInfo;
      this.loopProgress();
    },

    async loopProgress() {
      await BaseApi.createRpcToken("/import/progressQuery", {
        importId: this.importId,
      }).then(
        (data) => {
          if (data.code == 200) {
            clearTimeout(this.timer);
            const progress = data.datas.progress;
            this.progressInfo = progress;
            if (
              progress.importStatus === "SUCC" ||
              progress.importStatus === "FAIL"
            ) {
              this.close();
              this.exportResultVisible = true;
              this.resetList();
            } else {
              this.importProgressShow = true;
              this.timer = setTimeout(async () => {
                await this.loopProgress();
              }, 1000);
            }
          } else {
            this.$message.error(data.message);
          }
        },
        (err) => {}
      );
    },

    // 重置list
    resetList() {
      this.queryParams.pageNumber = 1;
      this.getList();
    },

    close() {
      this.batchUploadVisible = false;
      this.uploadRecordVisible = false;
      this.exportResultVisible = false;
      this.importProgressShow = false;
    },

    // 存草稿
    async saveDraft(data, type) {
      let ids = "";
      if (type === "single") {
        ids = data.id;
      } else {
        if (!data.length) {
          this.$message.error("请先选择");
          return;
        }
        ids = data.map((item) => item.id).join(",");
      }
      await BaseApi.createRpcToken("/import/batchSaveDraft", {
        ids,
      }).then(
        (data) => {
          if (data.code == 200) {
            if (type === "single") {
              // this.$message.success("提交成功");
            } else {
              // this.$message.success("提交成功");
            }
            this.getList();
          } else {
            this.$message.error(data.message);
          }
        },
        (err) => {}
      );
    },

    // 提交
    saveBatchSubmit(info, type) {
      let ids = "";
      if (type === "single") {
        ids = info.id;
      } else {
        if (!this.selectSubmitList.length) {
          this.$message.error("请先选择");
          return;
        }
        ids = this.selectSubmitList.map((item) => item.id).join(",");
      }
      if (this.isClick) {
        return;
      }
      this.isClick = true;
      BaseApi.createRpcToken("/import/batchSubmit", {
        ids,
      }).then(
        (data) => {
          if (data.code == 200) {
            if (type === "single") {
              this.$message.success("提交成功");
            } else {
              this.$message.success(
                `${this.selectSubmitList.length}条数据提交成功`
              );
            }
            // this.getList();
            this.$router.push("/personal/sign/home");
          } else {
            this.$message.error(data.message);
          }
          this.isClick = false;
        },
        (err) => {}
      );
    },

    // 删除
    batchDelete(data, type) {
      this.$confirm("删除后以上业务数据将无法还原，是否确认删除?", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.batchDeleteHandler(data, type);
        })
        .catch(() => {});
    },
    batchDeleteHandler(data, type) {
      let ids = "";
      if (type === "single") {
        ids = data.id;
      } else {
        if (!this.selectList.length) {
          this.$message.error("请先选择");
          return;
        }
        ids = this.selectList.map((item) => item.id).join(",");
      }
      BaseApi.createRpcToken("/import/batchDelete", {
        ids,
      }).then(
        (data) => {
          if (data.code == 200) {
            if (type === "single") {
              this.$message.success("删除成功");
            } else {
              this.$message.success(`${this.selectList.length}条数据删除成功`);
            }
            this.getList();
          } else {
            this.$message.error(data.message);
          }
        },
        (err) => {}
      );
    },

    // 总金额查询
    getTotalAmount() {
      if (this.totalAmountLoading) {
        return;
      }
      this.totalAmountLoading = true;
      BaseApi.createRpcToken("/import/queryTotalAmount", {
        ...this.form,
      }).then(
        (data) => {
          this.totalAmountLoading = false;
          if (data.code == 200) {
            this.totalAmount = data.datas.totalAmount;
          } else {
            this.$message.error(data.message);
          }
        },
        (err) => {
          this.totalAmountLoading = false;
        }
      );
    },

    // 编辑
    onEdit(data) {
      console.log(data, "data");
      sessionStorage.setItem("batchEdit", JSON.stringify(data));
      this.$router.push("/initiation/single?batchEdit=1");
    },

    // 手动创建
    toSingle() {
      this.$router.push("/initiation/single");
    },

    // 回到顶部
    onBacktop() {
      document.body.scrollIntoView({
        behavior: "smooth",
      });
    },

    //  受托列表 /user/listAssignee
    getListAssignee() {
      BaseApi.createRpcToken("/user/listAssignee", "", "post").then((data) => {
        if (data && data.datas) {
          this.listAssignee = data.datas.list;
        }
      });
    },
  },
};
</script>

<style scoped lang='scss'>
.single_container {
  background-color: #eaedf1;
  width: 100%;
  min-height: 100vh;
  padding-top: 60px;
  .personalMainHead {
    width: 100%;
    height: 60px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
  }

  .info_box {
    width: 100%;
    min-width: 1200px;
    min-height: 80vh;
    overflow: auto;
    background-color: #fff;
    margin: 5px auto 0px;
    padding: 32px 56px 0;
    box-sizing: border-box;
    .label {
      display: flex;
      align-items: center;
      margin-bottom: 23px;
      .line {
        width: 4px;
        height: 20px;
        background: #d81212;
        border-radius: 4px;
        margin-right: 10px;
      }
    }
  }
}

.el-form-item {
  margin-bottom: 0;
}
.task_form {
  margin-bottom: 53px;
}
.row {
  display: flex;
  align-items: center;
  .col {
    flex: 1;
  }
  .button-box {
    flex-shrink: 0;
    width: 166px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.tools {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .tools-left {
    flex: 1;
    display: flex;
    align-items: center;
    .number {
      font-size: 14px;
      font-weight: 400;
      color: #bdbdbd;
      line-height: 20px;
      margin-right: 12px;
    }
  }
  .tools-right {
    display: flex;
    align-items: center;
  }
}

.search-button {
  background: #f8f8f8;
  border-radius: 2px;
  border-color: #e9e9e9;
  color: #bdbdbd;
  padding: 7px 15px;
  &.el-button:focus,
  &.el-button:hover {
    color: none;
  }
}

.reset-button {
  border-radius: 2px;
  padding: 7px 15px;
  &.el-button--danger {
    color: #fff;
    background-color: #db1c1b;
    border-color: #db1c1b;
  }
}

::v-deep {
  .el-table-column--selection .cell {
    padding-left: 10px;
    padding-right: 10px;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #db1c1b;
    border-color: #db1c1b;
  }

  .el-button--mini {
    padding: 7px 15px;
  }
}

.status-box {
  display: flex;
  align-items: center;
}
.dot {
  width: 6px;
  height: 6px;
  background: #20ac78;
  border-radius: 50%;
  margin-right: 6px;
  &.dot-error {
    background: #db1c1b;
  }
}

.red-button {
  display: inline-block;
  color: #db1c1b;
  margin-right: 6px;
  padding: 0;
  &:last-child {
    margin-right: 0;
  }
}

.item-box {
  height: 40px;
  display: flex;
  align-items: center;
  .item {
    // width: 34px;
    width: 33.33%;
    height: 26px;
    border-radius: 2px;
    border: 1px solid #e9e9e9;
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #505050;
    line-height: 26px;
    text-align: center;
    margin-right: 4px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
    &.active {
      border: 1px solid #db1c1b;
      background: #db1c1b;
      color: #ffffff;
    }
  }
}

.pagination-box {
  display: flex;
  align-items: center;
  .pagination-left {
    font-size: 14px;
    line-height: 16px;
    color: #606266;
    .el-icon-refresh {
      color: #db1c1b;
      cursor: pointer;
      margin-left: 8px;
    }
    .el-icon-loading {
      color: #db1c1b;
      cursor: pointer;
      margin-left: 8px;
    }
  }
  .pagination {
    flex: 1;
    text-align: right;
  }
}

.backtop {
  position: fixed;
  right: 40px;
  bottom: 40px;
  background-color: #ffffff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #db1c1b;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 20px;
  -webkit-box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  z-index: 5;
}

.contract-name {
  display: flex;
  align-items: center;
  img {
    width: 21px;
    height: 18px;
    margin-left: 4px;
  }
}
</style>
